exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#documents_tab #planning_file_title {\n  width: 300px;\n}\n\n#documents_tab #documents_list {\n  margin-top: 16px;\n}\n\n#documents_tab #documents_list .document_item {\n  margin-top: 8px;\n}\n\n#documents_tab #documents_list .document_item .document_title {\n  font-weight: bold;\n  font-size: 16px;\n  margin-left: 4px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/planning/planning-modal/planning-modal.component.css
// module id = ../../../../../src/app/_components/planning/planning-modal/planning-modal.component.css
// module chunks = main